import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2253096"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0 20px"} }
const _hoisted_2 = ["loading"]
const _hoisted_3 = { class: "custom-tree-node" }
const _hoisted_4 = { style: {"padding":"0 5px"} }
const _hoisted_5 = {
  key: 0,
  style: {"padding-right":"20px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加子节点")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")

import { unref, watch, ref, defineComponent, reactive } from 'vue';
import { useRouter } from 'vue-router'
import { ElButton, ElTree, ElMessage, ElMessageBox } from 'element-plus';

/* Components */
import ModuleWriter from './components/ModuleWriter.vue'
import { GbDialog } from '@/components/GbDialog/Index';

/* API */
import { GetRtTreeApi, ModCreateApi, ModEditApi, ModDeleteApi } from '@/apis/modules/modules.api'

/* Types */
import { ModuleTree, ModuleInfo } from '@/apis/modules/modules.type';

interface Tree {
    id: string
    label: string
    enabled: string
    path?: string
    revision?: string
    children?: Tree[] | undefined
}

interface SelectRow {
    moduleId?: string,
    path?: string,
    title: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { push } = useRouter()

defineComponent([GbDialog])

const filterText = ref<string>('')
const selectRoot = ref<SelectRow>({ moduleId: '0', path: '/', title: '创建子模块' })

const createModel = ref<boolean>(false)
const showDialog = ref<boolean>(false)
const loading = ref<boolean>(false);
const treeData = ref<Tree[]>([{ id: 'root', label: '系统页面模块根节点', enabled: 'Y', path: '/', children: [] }]) // 必须存在一个根节点

const treeRef = ref<InstanceType<typeof ElTree>>()
const writerRef = ref<InstanceType<typeof ModuleWriter>>()

/* Watch方法组 */
watch(filterText, (val) => {
    treeRef.value?.filter(val)
})

/* 菜单树过滤 */
const filterNode = (value: string, data: Tree): boolean => {
    if (!value) return true
    return data.label.includes(value)
}

/* Ajax后续操作 */
const finallyAction = () => {
    loading.value = false
    showDialog.value = false

    getModulesTree()
}

/* 组装Tree */
const generateModuleTree = (data: Array<ModuleTree>): Array<Tree> => {

    const treeList = data.map((node: ModuleTree) => {
        return {
            id: node.id,
            label: node.name,
            enabled: node.is_enabled,
            path: node.path,
            revision: node.revision,
            children: node.child?.length || 0 > 0 ? generateModuleTree(node.child!) : []
        } as Tree
    })

    return treeList
}

/* 获取模块记录 */
const getModulesTree = () => {
    loading.value = true
    GetRtTreeApi().then((res) => {

        if (!res.succeeded) {
            ElMessage.error(`读取系统模块数据失败！原因可能是：${res.errors}`)
        } else {
            const moduleTree = generateModuleTree(res.data as ModuleTree[])
            treeData.value[0].children = moduleTree
        }
    }).finally(() => {
        loading.value = false
    })
}

/* 打开创建/修改窗口 */
const showWriterDialog = (row: Tree, isCreate: boolean) => {
    selectRoot.value = {
        moduleId: row.id == 'root' ? '0' : row.id,
        title: `创建子模块(父节点：${row.label})`
    }

    showDialog.value = true
    createModel.value = isCreate
}

/* 删除数据 */
const deleteModAction = (row: ModuleInfo) => {

    ElMessageBox.confirm("是否删除选中的数据？", "提示", { lockScroll: false, confirmButtonText: "确定", cancelButtonText: "取消", type: 'warning' })
        .then(() => {
            loading.value = true
            ModDeleteApi(row.id as string, row.revision).then(res => {
                if (!res.succeeded) {
                    ElMessage.error(`删除失败，可能的原因：${res.errors}。`);
                }
                else {
                    ElMessage.success(`删除成功。`);
                }
            }).finally(() => {
                loading.value = false
                getModulesTree()
            })
        })
}


/* 确认按钮 */
const onSureBtnClick = () => {
    const writer = unref(writerRef)

    writer?.formRef!.validate(async (valid) => {
        if (!valid) return

        loading.value = true

        const formData = writer?.methods.getFormData()
        const response = await (createModel.value ? ModCreateApi(formData) : ModEditApi(formData.pid, formData)).finally(finallyAction)

        if (!response.succeeded) {
            ElMessage.error(`操作成功，可能的原因：${response.errors}`)
        } else {
            ElMessage.success(`操作成功`)
        }
    })
}

getModulesTree()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form, {
            inline: true,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { style: {"width":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: filterText.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterText).value = $event)),
                    type: "text",
                    clearable: "",
                    placeholder: "请输入关键字查找节点"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", { loading: loading.value }, [
            _createVNode(_unref(ElTree), {
              ref_key: "treeRef",
              ref: treeRef,
              accordion: "",
              "node-key": "id",
              "default-expand-all": "",
              data: treeData.value,
              onFilterNodeMethod: filterNode,
              "expand-on-click-node": false
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(node.label) + " ", 1),
                    _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(data.path || '--') + ")", 1)
                  ]),
                  _createElementVNode("div", null, [
                    (data.id != 'root')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createVNode(_component_el_switch, {
                            modelValue: data.enabled,
                            "onUpdate:modelValue": ($event: any) => ((data.enabled) = $event),
                            "inline-prompt": "",
                            activeText: "启用",
                            "active-value": "Y",
                            "inactive-text": "停用",
                            "inactive-value": "N",
                            style: {"--el-switch-off-color":"#F56C6C"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      link: "",
                      onClick: ($event: any) => (showWriterDialog(data, true))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (data.id != 'root')
                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                          key: 1,
                          type: "success",
                          link: "",
                          onClick: ($event: any) => (showWriterDialog(data, false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (data.id != 'root')
                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                          key: 2,
                          type: "danger",
                          link: "",
                          onClick: ($event: any) => (deleteModAction(data))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["data"])
          ], 8, _hoisted_2)
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(GbDialog), {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
      title: selectRoot.value.title
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: onSureBtnClick
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          type: "info",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(ModuleWriter, {
          ref_key: "writerRef",
          ref: writerRef,
          "module-id": selectRoot.value.moduleId,
          "is-create": createModel.value
        }, null, 8, ["module-id", "is-create"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})